import type { TrigKey } from './keys';

export const fr: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Maths · Trigonométrie',
  'panel.experiment': 'Expérience',
  'panel.params': 'Paramètres',
  'panel.scene': 'Choisis une expérience',
  'experiment.right-triangle.label': 'Triangle rectangle',
  'experiment.unit-circle.label': 'Cercle trigonométrique',
  'experiment.wave-studio.label': 'Studio d’ondes',
  'experiment.identity-playground.label': 'Identités',
  'experiment.triangle-solver.label': 'Résolveur de triangles',
  'experiment.circular-polar.label': 'Circulaire & polaire',
  'hint.line1': 'Glisse les points et les curseurs.',
  'hint.line2': 'Le contenu pédagogique vit dans la géométrie, pas dans le texte.',
  'rt.angle.a': 'Angle A',
  'rt.angle.b': 'Angle B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Radians',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'Aligner sur 30°/45°/60°',
  'uc.units': 'Unités',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'Afficher ASTC',
  'uc.snap.common': 'Aligner sur angles communs',
  'uc.angle.value': '∠',
  'uc.units.deg': 'deg',
  'uc.units.rad': 'rad',
  'uc.units.both': 'deg+rad',
  'ws.fn': 'Fonction',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — Amplitude',
  'ws.frequency': 'B — Fréquence',
  'ws.phase': 'C — Déphasage',
  'ws.shift': 'D — Décalage vertical',
  'ws.rform.toggle': 'Forme R',
  'ws.rform.a': 'a (coef. sin)',
  'ws.rform.b': 'b (coef. cos)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Réinitialiser',
  'ws.base': 'Afficher la courbe de base',
  'ip.id.pythagorean': 'Pythagore',
  'ip.id.reciprocal': 'Réciproque',
  'ip.id.quotient': 'Quotient',
  'ip.id.sum': 'Somme',
  'ip.id.difference': 'Différence',
  'ip.id.double': 'Angle double',
  'ip.id.half': 'Demi-angle',
  'ip.play': 'Lecture',
  'ip.pause': 'Pause',
  'ip.step': 'Pas',
  'ip.reset': 'Réinitialiser',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note':
    'À venir en v2 — cette démonstration nécessite une construction plus élaborée.',
  'ts.area': 'Aire',
  'ts.sineRule': 'Loi des sinus',
  'ts.cosineRule': 'Loi des cosinus',
  'ts.ambiguous.toggle': 'Afficher le triangle fantôme en cas d’ambiguïté',
  'ts.reset': 'Revenir à équilatéral',
  'ts.snap.integers': 'Aligner sur entiers',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Côtés',
  'ts.section.angles': 'Angles',
  'ts.section.sineRule': 'Loi des sinus',
  'ts.section.cosineRule': 'Loi des cosinus',
  'ts.section.area': 'Aire',
  'cp.omega': 'Vitesse angulaire',
  'cp.plot.y': 'Tracer y (sin)',
  'cp.plot.x': 'Tracer x (cos)',
  'cp.polar.label': 'Figure polaire',
  'cp.polar.circle': 'Cercle (r = 1)',
  'cp.polar.rose': 'Rosace (r = sin 3θ)',
  'cp.polar.cardioid': 'Cardioïde (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limaçon (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Petits angles (sin x ≈ x)',
  'cp.play': 'Lecture',
  'cp.pause': 'Pause',
  'cp.reset': 'Réinitialiser',
  'cp.step': 'Pas π/12',
};
